import { apiClient } from '@/lib/api/client'

export interface TicketSourceItem {
  name: string
  value: number
  color: string
}

export interface TicketSource {
  period: string
  total_active: number
  sources: TicketSourceItem[]
}

export interface AgentPerformanceItem {
  agent_id: number
  name: string
  initials: string
  team: string
  open_ticket: number
  status: string
  avg_frt_seconds: number
  csat: number | null
  load_percent: number
}

export interface HelpdeskDashboardStats {
  unresolved: number
  overdue: number
  due_today: number
  open: number
  on_hold: number
  unassigned: number
  resolved: number
  received: number
  average_first_response_seconds: number
  resolution_within_sla_percent: number
  trends_today: number[]
  trends_yesterday: number[]
  kpi_open: number
  kpi_on_hold_parts: number
  kpi_on_hold_customer: number
  kpi_resolved_incomplete: number
  kpi_closed: number
  kpi_cancelled: number
  ticket_source: TicketSource
  agent_performance: AgentPerformanceItem[]
}

export const helpdeskDashboardService = {
  async getStats(): Promise<HelpdeskDashboardStats> {
    const res = await apiClient.get('/helpdesk/dashboard/stats')
    return res.data
  },
}